import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { CFCProps, EntityType } from 'types';
import { useDispatch, connect, useSelector } from 'react-redux';
import { fetchEnquiryById, fetchResetLodgeEnquiry } from 'redux/enquiries';
import { clearLodgeEnquiryDetails } from 'redux/lodgeEnquiry';
import { selectUser } from 'redux/user/selector';
import { selectIsFromSwxLocate } from 'redux/session/selectors';
import {
  updateShowNotificationOptionsModal,
  updateUserStart
} from 'redux/user/actions';
import { submitCollect } from 'redux/track/actions';
import { RootState } from 'redux/root.reducer';
import Utils from 'utilities/helper.util';
import { ResponseCollationNotification } from './components';
import { EnquiryDetailsNew } from '../enquiryDetailsNew';

const mapStateToProps = ({
  enquiresCache,
  lodgeEnquiryCache,
  session,
  announcementCache
}: RootState) => ({
  enquiry: enquiresCache?.data?.enquiry,
  isLoading: enquiresCache?.enquiryLoader,
  newEnquiryDetails: lodgeEnquiryCache?.enquiry,
  isEnquirySubmitting: lodgeEnquiryCache?.submitting,
  screenSize: session.screenSize,
  announcements: announcementCache?.announcements
});
const connector = connect(mapStateToProps);
type Props = CFCProps<typeof connector>;

export const EnquiryDetails: React.FC<Props | any> = (props: Props) => {
  const { enquiry, newEnquiryDetails }: any = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const isFromSwxLocate = useSelector(selectIsFromSwxLocate);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [enquiryDetail, setEnquiryDetail] = useState<any>();

  const queryString = new URLSearchParams(history?.location.search);
  const shareId = queryString.get('shareId') || '';
  const sourceChannel = queryString.get('src') || '';
  const action = queryString.get('action') || '';
  const isDisplay = !!shareId || action === 'view' || isFromSwxLocate;

  const handleOnToastClose = useCallback(() => setShowToast(false), []);

  const handleOnSetupClick = useCallback(() => {
    handleOnToastClose();
    dispatch(updateShowNotificationOptionsModal(true));
  }, [dispatch, handleOnToastClose]);

  useEffect(() => {
    return () => {
      dispatch(clearLodgeEnquiryDetails());
      dispatch(fetchResetLodgeEnquiry());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!Utils.isObjectEmpty(newEnquiryDetails) || enquiry) {
      let enquiryId = '';
      if (newEnquiryDetails?.Referrals) {
        enquiryId = newEnquiryDetails.id;
      } else {
        enquiryId = enquiry.id;
      }

      if (shareId) {
        dispatch(
          submitCollect({
            payload: {
              enquiryId,
              shareId,
              ...(sourceChannel === 'email' ? { sourceChannel: 'email' } : {})
            },
            type: EntityType.VIEW_COPY_LINK
          })
        );
      }
    }

    setEnquiryDetail(
      !Utils.isObjectEmpty(newEnquiryDetails) ? newEnquiryDetails : enquiry
    );
  }, [enquiry, newEnquiryDetails, dispatch, shareId, sourceChannel]);

  useEffect(() => {
    if (!enquiryDetail) {
      let request:
        | string
        | { enquiryId: string; shareId?: string; logo: boolean };
      const enquiryId = history?.location?.pathname.split('/')[2];
      const logo = true;
      if (shareId) {
        request = { enquiryId, shareId, logo };
      } else {
        request = { enquiryId, logo };
      }
      enquiryId && dispatch(fetchEnquiryById(request));
    }
  }, [enquiryDetail, history, dispatch, shareId]);

  useEffect(() => {
    // if user do not have notification setting show toast message and update to default value
    if (user && !user.preferences?.notificationSetting && !isDisplay) {
      setShowToast(true);
      dispatch(
        updateUserStart({
          preferences: { notificationSetting: 'ALL_RECEIVED' }
        })
      );
    }
  }, [user, dispatch, isDisplay]);

  return (
    <>
      <EnquiryDetailsNew isDisplay={isDisplay} shareId={shareId} />
      {showToast && !isDisplay && !isFromSwxLocate ? (
        <ResponseCollationNotification
          onClose={handleOnToastClose}
          onSetup={handleOnSetupClick}
        />
      ) : null}
    </>
  );
};

EnquiryDetails.displayName = 'LodgeEnquiryStep1From';

export default connector(EnquiryDetails);
